isPostEvent